<template lang="html">
    <div class="flex-col diagnostic-container">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="css">
  .diagnostic-table {
    background: #fff;
    width: 100%;
    border-radius: 20px;
  }
  .diagnostic-container {
   margin: 0 auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Diagnostic.vue